<template>
  <div>
    <!-- <v-divider></v-divider> -->
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down>
        <v-navigation-drawer style="z-index:2000;" class="fixedSidebar" v-model="sideNav" clipped dark src=".././assets/sidenav.png"
          overlay-color="white" width="100%" height="100vh" permanent color="#3F033B">
          <v-layout wrap fill-height>
            <v-flex xs12 align-self-start>
          <v-layout wrap>
          <v-flex xs12 py-6 align-self-center>
            <!-- <v-card tile height="70px" color="transparent"> -->
            <router-link to="/">
              <span style="
                      font-family: RBold;
                      color: white;
                      font-size: 28px;
                    ">Chanakya</span>
                   
            </router-link>
            <!-- </v-card> -->
          </v-flex>
          </v-layout>
          <!---------------------------------- SuperAdmin sidebar-------------------------------------------->
          <v-layout wrap>
            <v-flex xs12 text-left text-uppercase align-self-center v-if="navItems && this.appType == 'SuperAdmin'">
              <v-list dense v-for="(main, i) in navItems" :key="i" class="subhed">
                <v-layout wrap >
                  <v-flex xs12 mx-2 :style="
                          $route.path == main.menu.route
                            ? 'background-color:rgba(192,192,192,0.3)'
                            : 'background-color:transparent'
                        " >
                    <router-link :to="main.menu.route">
                    <!-- <v-list-group no-action :value="false" active-class="activated"> -->
                      <!-- <template v-slot:activator> -->
                        <v-layout wrap justify-center>
                                <v-flex xs2 align-self-center>
                        <v-list-item-icon :style="
                          $route.path == main.menu.route
                            ? 'color:white'
                            : 'color:white'
                        ">
                          <v-img height="20px" contain :src="main.menu.src"></v-img>
                        </v-list-item-icon>
                      </v-flex>
                        <v-flex xs10 align-self-center>
                        <!-- <router-link :to="main.menu.route"> -->
                          <v-list-item-title style="
                                letter-spacing: 2px;
                                color: black;
                                cursor: pointer;
                              ">
                             
                                  <span class="text-none title1" :style="
                          $route.path == main.menu.route
                            ? 'color:white'
                            : 'color:white'
                        " >
                              {{ main.menu.name }}
                            </span>
                                <!-- </v-flex>
                              </v-layout> -->
                           
                          </v-list-item-title>
                          </v-flex>
                          </v-layout>
                        <!-- </router-link> -->
                      <!-- </template> -->
                      <!-- submenu -->
                      <!-- <v-flex xs12 py-1 px-4>
                        <div style="border-bottom: 1px dotted black"></div>
                      </v-flex> -->
                      <div v-if="main.menu.subMenu" class="subhed">
                        <template v-for="(sub, i) in main.menu.subMenu">
                          <v-flex xs12 text-left pl-6 py-1 :style="
                            $route.path == sub.route
                              ? ''
                              : 'background:rgba(0, 0, 0, 0.1)'
                          "  :key="i">
                            <v-layout wrap justify-center>
                              <v-flex xs12>
                                <router-link :to="sub.route">
                                  <span style="letter-spacing: 3px; cursor: pointer">
                                    <span class="text-none" :style="
                                      $route.path == sub.route
                                        ? 'color:#ffffff'
                                        : 'color: #ffffff'
                                    " style="
                                letter-spacing: 2px;
                                font-size: 13px !important;
                                cursor: pointer;
                              ">
                                     -> {{ sub.name }}
                                    </span>
                                  </span>
                                </router-link>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- <v-flex xs12 py-1 px-4 pl-6 :key="sub._d">
                          <div style="border-bottom: 1px solid grey"></div>
                        </v-flex> -->
                        </template>
                      </div>
                      <!-------------->
                    <!-- </v-list-group> -->
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-flex>
            <v-flex xs12 text-left py-2 text-uppercase align-self-center v-if="navItems && this.appType != 'SuperAdmin'">
              <span style="color:white;"></span>
                <v-layout wrap>
            <v-flex xs6 align-self-center pl-4 pb-3>
              <span v-if="appType == 'SuperAdmin' || appType == 'ConstituencyPresident' || appType == 'Aspirant' || appType == 'BoothPresident' || appType == 'BoothAgent'" @click="$router.push('/')" class="subhed text-none" style="color: #ffffff !important; cursor: pointer;">
                             DASHBOARD
                            </span>
            </v-flex>
           </v-layout>
              <v-list dense v-for="(main, i) in navItems" :key="i">


                <v-layout wrap v-if="main">
                  <v-flex xs12>
                    <router-link :to="main.menu.route">
                    <v-list-group no-action :value="false" active-class="activated">
                      <template v-slot:activator>
                        <!-- <v-list-item-icon :style="
                          $route.path == main.menu.route
                            ? 'color:white'
                            : 'color:white'
                        ">
                          <v-img height="20px" contain :src="require(../assets/icons/right.png)"></v-img>
                        </v-list-item-icon> -->
                          <span class="text-none subhed" style="color: #ffffff!important; text-transform: uppercase !important;  cursor: pointer;">
                            {{ main.menu.name }}
                          </span>
                      </template>
                    </v-list-group>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-flex>
            <v-flex xs2 @click="appLogout()" align-self-center pl-1 pb-3 pt-1 v-if="appType == 'SuperAdmin'">
              <v-img height="20px" contain src="../assets/icons/power.png"></v-img>
              <!-- <v-icon color="white">mdi-power</v-icon> -->
            </v-flex>
            <v-flex @click="appLogout()" xs6 align-self-center text-left pl-2 pb-3 pt-3 v-if="appType == 'SuperAdmin'">
              <span   class="text-none" style="color: #ffffff!important;font-size:16px!important;font-family: RRegular; cursor: pointer;">
                             Logout
                            </span>
            </v-flex>
          </v-layout>
          </v-flex>
          <v-flex xs12 align-self-end>

          <!-- <v-layout wrap>
            <v-flex xs12 py-2 align-self-baseline style="color:white" text-left px-4>
              <v-icon>mdi-power</v-icon>LOGOUT
            </v-flex>
          </v-layout> -->
        </v-flex>
        </v-layout>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10 pt-12 pt-lg-0>
        <AppHeader />
        <!-- <AppHeader v-if="!isMPDashboardRoute" /> -->
        <v-layout wrap justify-center style="background-color: #f9f6ff; min-height: 100vh">
          <v-flex xs12 :class="contentClass">
            <router-view :key="$route.fullPath"></router-view>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AppHeader from "./../layout/AppHeader";
import axios from "axios";
import store from "./../store";

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      sideNav: true,
      admin: [{ name: "ADMINS", route: "/Admins" }],
      userNavItemsSuperAdmin: [
        {
          menu: {
            name: "Dashboard",
            route: "/home",
            src: require("../assets/icons/send2.png"),
          
          },
        },
        // {
        //   menu: {
        //     name: "Election",
        //     route: "/ElectionType",
        //     src: require("../assets/icons/election2.png") ,
        //   },
        // },
        {
          menu: {
            name: "Political Party",
            route: "/PoliticalParty",
            src: require("../assets/icons/party.png"),
          },
        },
        {
          menu: {
            name: " President",
            route: "/addConstituencyPresident",
            src: require("../assets/icons/candidate.png"),
          },
        },
        // {
        //   menu: {
        //     name: "Aspirants",
        //     route: "/CandidateAspirants",
        //     src: require("../assets/icons/candidate.png"),
        //   },
        // },
        {
          menu: {
            name: "Constituency",
            route: "/addConstituency",
            src: require("../assets/icons/panchayat.png"),
          },
        },
        // {
        //   menu: {
        //     name: "Panchayat",
        //     route: "/addPanchayat",
        //     src: require("../assets/icons/parliament.png"),
        //   },
        // },
        // {
        //   menu: {
        //     name: "Ward",
        //     route: "/addWard",
        //     src: require("../assets/icons/ward.png"),
        //   },
        // },
        {
          menu: {
            name: "Booth",
            route: "/BoothList",
            src: require("../assets/icons/booth.png"),
          },
        },
        {
          menu: {
            name: "Voters List",
            route: "/VotersList",
            src: require("../assets/icons/voters.png"),
          },
        },
        // {
        //   menu: {
        //     name: "SETTINGS",
        //     route: "/MenuManagement",
        //     src: require("../assets/icons/settings.png"),
        //   },
        // },
      ],
    };
  },
 
  computed: {
    contentClass() {
      return this.$route.path === '/home' ? '' : 'pa-6';
    },
    appType() {
      return this.$store.state.userType;
    },
    userNavItemsStaffAdmin1(){
      return this.$store.state.menu;
    },
    navItems() {
      if (this.appType == "SuperAdmin") return this.userNavItemsSuperAdmin;
      // else if (this.appType == "JewelleryAdmin")
      //   return this.userNavItemsSuperAdmin;
      // else if (this.appType == "Staff") return this.userNavItemsSuperAdmin;
      else return this.userNavItemsStaffAdmin1;
  },
  isMPDashboardRoute() {
      return this.$route.path === '/home';
      // || this.$route.path === '/MPDashboard'
    },
},
  methods: {
    appLogout() {
      axios({
        method: "get",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status==true) {
            this.$store.commit("logoutUser", true);
            localStorage.removeItem("id");
            // store.commit("menu", response.data.menus);
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.v-list-group__header__append-icon {
  display: none !important;
}

@media only screen and (min-device-width: 767px) {
  .fixedSidebar {
    /* position: fixed; */

    position: -webkit-sticky;
    /* Safari */
    position: sticky;
    top: 50;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 640px) {
  .fixedSidebar {
    display: none !important;
  }
}

/* .activated { */
.activated {
  color: rgba(63, 3, 59, 0.9) !important;
}

.deactivated {
  color: rgba(63, 3, 59, 0.9) !important;
}

/* } */
</style>
